// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-card {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}

.item-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.item-image-container {
  width: 100%;
  padding-top: 100%;
  position: relative;
  background-color: #ddd5c7;
  overflow: hidden;
}

.item-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-light);
  background-color: #ddd5c7;
  font-family: var(--font-body);
}

.item-info {
  padding: 16px;
}

.item-name {
  font-family: var(--font-body);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
  color: var(--dark);
}

.item-category {
  font-size: 13px;
  color: var(--text-light);
  margin-bottom: 8px;
}

.item-price {
  font-size: 20px;
  font-weight: 700;
  color: var(--gold);
  margin-bottom: 8px;
}

.out-of-stock {
  display: inline-block;
  padding: 4px 8px;
  background-color: #fee;
  color: var(--error);
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ItemCard.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".item-card {\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: 16px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.item-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.item-image-container {\n  width: 100%;\n  padding-top: 100%;\n  position: relative;\n  background-color: #ddd5c7;\n  overflow: hidden;\n}\n\n.item-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.item-image-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-light);\n  background-color: #ddd5c7;\n  font-family: var(--font-body);\n}\n\n.item-info {\n  padding: 16px;\n}\n\n.item-name {\n  font-family: var(--font-body);\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 4px;\n  color: var(--dark);\n}\n\n.item-category {\n  font-size: 13px;\n  color: var(--text-light);\n  margin-bottom: 8px;\n}\n\n.item-price {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--gold);\n  margin-bottom: 8px;\n}\n\n.out-of-stock {\n  display: inline-block;\n  padding: 4px 8px;\n  background-color: #fee;\n  color: var(--error);\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
